import Loadable from 'react-loadable';

const ReturnToJiraIntegration = Loadable<any, any>({
  loader: () => import(/* webpackChunkName: "ReturnToJiraIntegration" */ './ReturnToJiraIntegration'),
  loading: () => null,
});

export default ReturnToJiraIntegration;
